// Source
import * as Instance from "../Instance";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelDocument from "../../model/custom/Document";

export const dataList = (document: ModelDocument.Idata, sortOrder: string, page: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        sort_order: sortOrder,
        page: page,
        project_name: document.project_name,
        client_name: document.client_name,
        client_industry: document.client_industry,
        filename: document.filename || "",
        reporting_year: document.reporting_year,
        template_language: document.template_language || "",
        latest_update: document.latest_update,
        latest_update_by_id: document.latest_update_by_id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/nintex/data_list?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const createData = (formData: FormData, callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .post<ModelHelperSrc.Iresponse>("/nintex/create_data", {}, formData)
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const removeData = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/nintex/remove_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const checkTaskStatus = (taskName: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        task_name: taskName
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/nintex/check_task_status",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const downloadDocx = (filename: string | undefined, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        filename
    };

    if (filename) {
        Instance.api
            .post<ModelHelperSrc.Iresponse>(
                "/nintex/download_docx",
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                },
                data
            )
            .then((response) => {
                return callback(response.data);
            })
            .catch((error: Error) => {
                return callback(error);
            });
    }
};

export const downloadStaticTemplate = (filename: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        filename
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/nintex/download_static_template",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const selectOption = (callback: ModelHelperSrc.IapiCallback, templateLanguage = ""): void => {
    const data = {
        template_language: templateLanguage
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/nintex/select_option?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const validationForm = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/nintex/validation_form", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const previewData = (id: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/nintex/preview_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const saveData = (documentPreview: ModelDocument.Idata, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        id: documentPreview.id,
        section_data: window.btoa(encodeURIComponent(JSON.stringify(documentPreview.section_data))),
        client_name: documentPreview.client_name,
        client_industry: documentPreview.client_industry,
        project_name: documentPreview.project_name,
        reporting_year: documentPreview.reporting_year
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/nintex/save_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const updateData = (documentPreview: ModelDocument.Idata, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id: documentPreview.id, section_data: window.btoa(encodeURIComponent(JSON.stringify(documentPreview.section_data))) };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/nintex/update_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const downloadPdf = (filename: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { filename };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/nintex/download_pdf",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};
